export default __webpack_public_path__ + "static/media/Fail.43530f99.svg";